(() => {
  const emitSecondaryEvent = (eventName, parameters = {}) => {
    const eventParameters = {
      ...parameters,
      page_location: window.location.href,
      page_path: window.location.pathname,
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParameters);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...eventParameters });
    }

    document.dispatchEvent(
      new CustomEvent('handymite:secondary-event', {
        detail: { event: eventName, ...eventParameters },
      }),
    );
  };

  if (!window.__handymiteAmazonClickBound) {
    window.__handymiteAmazonClickBound = true;
    document.addEventListener('click', (event) => {
      const amazonLink = event.target?.closest?.('[data-handymite-amazon-link]');
      if (!amazonLink) return;
      const publisher = window.Shopify?.analytics;
      if (typeof publisher?.publish !== 'function') {
        console.warn('HandyMite Amazon tracking: Shopify analytics unavailable');
        return;
      }
      const parameters = {
        link_url: amazonLink.href,
        link_domain: new URL(amazonLink.href).hostname,
        product_id: amazonLink.dataset.productId || '',
        product_handle: amazonLink.dataset.productHandle || '',
        product_name: amazonLink.dataset.productTitle || '',
        page_location: window.location.href,
        page_path: window.location.pathname,
      };
      // A QA marker identifies internal validation only; normal clicks have none.
      const qa = new URL(window.location.href).searchParams.get('hm_qa');
      if (qa && /^amz_[a-zA-Z0-9_]{1,60}$/.test(qa)) parameters.qa_run_id = qa;
      publisher.publish('amazon_outbound_click', parameters);
    });
  }

  const newsletterSuccess = document.querySelector('.newsletter-form__message--success');
  if (!newsletterSuccess) return;

  const newsletterForm = newsletterSuccess.closest('form');
  const source = newsletterForm?.id === 'ContactFooter' ? 'footer' : 'section';
  const dedupeKey = `handymite_email_signup_success:${window.location.pathname}:${source}`;

  if (window.sessionStorage.getItem(dedupeKey)) return;

  window.sessionStorage.setItem(dedupeKey, '1');
  emitSecondaryEvent('email_signup_success', {
    signup_source: source,
    form_id: newsletterForm?.id || '',
  });
})();
